<template>
  <div style="height:97%; padding: 10px;overflow: hidden">
    <el-tabs v-model="activeName"  @tab-click="handleClick">
    <el-tab-pane label="指标管理" name="first">
       <el-row>
      <el-form :inline="true" :model="ruleForm" class="demo-form-inline">
        <!-- <el-form-item label="">
          <el-input v-model="input" placeholder="请输入单位查找"  @keyup.enter.native="Onsearch"></el-input>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-button type="txt" plain @click="Onsearch" size="small" icon="el-icon-search" 
            >查询</el-button>
          <el-button type="txt" plain size="small" icon="el-icon-s-claim" @click="All"
            >显示全部</el-button> -->
           <el-button type="txt" plain size="small" icon="el-icon-circle-plus" @click="AddDomainindicators"
            >添加数据</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <!-- 添加 -->
    <add-domainindicators :dialogVisible="AddInfo" @CloseAdd="CloseAdd" @getData="getData"></add-domainindicators>
    <!-- 修改 -->
    <upd-domainindicators :dialogVisible="UpdateInfo" :ruleForm="ruleForm" @CloseUpdate="CloseUpdate" @getData="getData"></upd-domainindicators>
    <el-table
    :data="tableData"
    :height="tableHeight"
    border
    style="width: 100%"
    :row-class-name="tableRowClassName"
    :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
        background: '#26115e ',
        color: 'white',
        textAlign: 'center',
    }">
    <el-table-column fixed prop="id" label="序号" ></el-table-column>
    <el-table-column prop="domain_id" label="所属领域" width="120">
      <template slot-scope="{ row }">
            <el-tag type="primary" v-if="row.domain_id == 21">微电子光电子</el-tag>
            <el-tag type="success" v-if="row.domain_id == 22">光学工程</el-tag>
             <el-tag type="danger" v-if="row.domain_id == 23">感知</el-tag>
            <el-tag type="info" v-if="row.domain_id == 24">测量计量</el-tag>
             <el-tag type="warning" v-if="row.domain_id == 25">电磁空间</el-tag>
            <el-tag  v-if="row.domain_id == 26">网络与通信</el-tag>
            <el-tag type="danger" v-if="row.domain_id == 27">信息安全</el-tag>
            <el-tag type="success" v-if="row.domain_id == 28">水声工程</el-tag>
             <el-tag type="primary" v-if="row.domain_id == 29">电子场与电磁环境效应</el-tag>
            <el-tag type="success" v-if="row.domain_id == 30">控制</el-tag>
             <el-tag type="danger" v-if="row.domain_id == 31">认知</el-tag>
             <el-tag type="primary" v-if="row.domain_id == 32">计算机系统及软件</el-tag>
            <el-tag type="info" v-if="row.domain_id == 33">计算机应用</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="index_description" label="数据描述" width="207"  :show-overflow-tooltip='true'></el-table-column>
    <el-table-column prop="index" label="精简指标" width="140"></el-table-column>
    <el-table-column prop="unit" label="单位" width="120"></el-table-column>
    <el-table-column prop="classification" label="指标类别" width="120"></el-table-column>
     <el-table-column prop="importance" label="重要性" width="120"></el-table-column>
    <el-table-column label="各国数据">
     <el-table-column prop="source_foreign" label="数据来源" width="120" :show-overflow-tooltip='true'></el-table-column>
     <el-table-column prop="permission_foreign"  label="可获得性" width="120"  :show-overflow-tooltip='true'></el-table-column>
     <el-table-column prop="range_foreign" label="数据范围" width="120"  :show-overflow-tooltip='true'></el-table-column>
     <el-table-column prop="frequency_foreign" label="更新频率" width="120" :show-overflow-tooltip='true'></el-table-column>
     <el-table-column prop="link_foreign" label="来源链接" width="120" :show-overflow-tooltip='true'></el-table-column>
    </el-table-column>
    <el-table-column label="中国数据">
    <el-table-column prop="source" label="数据来源" width="120" :show-overflow-tooltip='true'></el-table-column>
    <el-table-column prop="permission" label="可获得性" width="120"  :show-overflow-tooltip='true'></el-table-column>
    <el-table-column prop="frequency" label="更新频率" width="120" :show-overflow-tooltip='true'></el-table-column>
    <el-table-column prop="link" label="来源链接" width="120" :show-overflow-tooltip='true'></el-table-column>
    </el-table-column>
    <el-table-column prop="comment" label="备注" width="120" :show-overflow-tooltip='true'></el-table-column>
    <el-table-column fixed="right" label="操作" width="100">
      <template slot-scope="scope">
        <el-button @click="Handlechange(scope.row)" type="text" size="small">修改</el-button>
        <el-button @click="Handledeteled(scope.row)" type="text" size="small">删除</el-button>
      </template>
    </el-table-column>
    </el-table>
   <el-pagination
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalPage"
      >
    </el-pagination>
    </el-tab-pane>
    <el-tab-pane label="热点指标" name="second">
      <div id="WordCloudPicture" ref="container"></div>
    </el-tab-pane>
  </el-tabs>

  </div>
</template>

<script>
import api from "@/services/python";
import AddDomainindicators from './AddDomainindicators.vue';
import UpdDomainindicators from './UpdDomainindicators.vue';
import CONSTANCE from "@/static/js/constance";
import WordCloud from "wordcloud";
import WordCloudPicture from './WordCloudPicture.json';
// import  "echarts-wordcloud";
export default {
    components:{
        AddDomainindicators,
        UpdDomainindicators
    },
    mounted(){
      this.initChart()
       //挂载window.onresize事件(动态设置table高度)
        let _this = this;
        window.onresize = () => {
          if (_this.resizeFlag) {
            clearTimeout(_this.resizeFlag);
          }
          _this.resizeFlag = setTimeout(() => {
            _this.getTableHeight();
            _this.resizeFlag = null;
          }, 100);
        }
    },
    data() {
      return {
        tableHeight: "",//表格高度
        activeName: 'second',
        currentPage: 1,
        pageSize:10,
        tableData: [],
        ruleForm: {},
        // input: "",
        AddInfo: false,
        UpdateInfo:false,
        totalPage:0,
      }
    },
    created(){
        this.getData()
        this.getTableHeight();
    },
    methods: {
      //计算table高度(动态设置table高度)
    getTableHeight() {
      let tableH = 220; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    tableRowClassName() {
      return "warning-row";
    },
      // 词云图
      initChart() {
        // const params = {top_n:10},
        const res =  WordCloudPicture
        if(res.code == 200){
          const max = Math.max(...res.data.map((x) => x.value));
        const list = res.data.map((data) => {
          const { word, value } = data;
          return [word, Math.floor((value * CONSTANCE.WORD_CLOUD_SIZE) / max)];
        });
        WordCloud(this.$refs.container, {
          list: list,
        });
        }
        
      //   api.key_index.word_clouding.create({
      //   top_n: 10,
      // })
      // .then((res) => {
        
      // });
      },
        handleClick(tab, event) {
          console.log(tab, event);
        },
        // 增加
        AddDomainindicators(){
          this.AddInfo = true;
        },
        CloseAdd() {
          this.AddInfo = false;
          // 自刷新
          this.getData();
        },
        // // 查询
        // Onsearch(){
        //   this.tableData = this.tableData.filter((item) => {
        //   if (item.unit.includes(this.input)) {
        //     console.log("item", item);
        //     return item;
        //   }
        //   });
        // },
        // // 显示
        // All() {
        //   this.input = '';
        //    this.getData();
        // },
        // 删除
        Handledeteled(item){
            this.$confirm("此操作将永久删除, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                const res = await api.key_index.delete(item.id).response.then((res) => res.data);
                if (res.code == 200) {
                  this.$message.success("删除成功");
                } else {
                  this.$message.error("删除失败");
                }
                this.currentPage = 1;
                this.getData();
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
        },
        // 修改
      Handlechange(item) {
        this.ruleForm = JSON.parse(JSON.stringify(item));
        this.UpdateInfo = true;
      },
      CloseUpdate(){
        this.UpdateInfo = false;
          // 自刷新
        this.getData();
      },
      HandleSizeChange(val) {
      this.pageSize = val;
    },
    HandleCurrentChange(val) {
        this.currentPage = val;
        this.getData()
    },
     async getData(){
         const params = {
            page_size:this.pageSize,
            page_to: this.currentPage,
        };
        const res = await api.key_index.list({}, {params}).response.then((res) => res.data);
        if (res.code == 200) {
            this.tableData = res.data.records;
            this.totalPage = res.data.total_records
            console.log("this.tableData",this.tableData);
        }
      }
    },
}
</script>

<style scoped>
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
width: 6px; 
height: 6px; 
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
background-color: #ddd;
border-radius: 3px;
}
.el-pagination{
    text-align: center;
    position:fixed;
    bottom:0;
    left: 0;
    right: 0;
    margin: 0 auto;
}
/deep/.el-tabs__item{
  padding: 0px;
  margin-right:10px;
    /* background-color: rgb(8, 14, 32); */
    /* border-radius:5px; */
  color: rgb(188 230 236 / 50%);
}
/deep/.el-tabs__item:hover {
    color: #eee;
    cursor: pointer;
}
/deep/.el-tabs__item.is-active {
  color: #eee;
}
/deep/.el-tabs__active-bar{
  background:transparent;
}
/deep/.el-input__inner{
  background: transparent;
  /* color: #eee; */
}
/deep/.el-pager li{
    background: transparent !important;
    color: #fff;
}
/deep/.el-pager li.active {
    color: #409EFF;
    cursor: default;
}
/deep/.el-pagination__total,
/deep/.el-pagination__jump{
  color: #fff;
}
/deep/.el-tabs__content{
   height:100%;
}
/deep/#pane-second{
  height:100%;
}
#WordCloudPicture{
  height:calc(100vh - 110px);
   width:100%;
  background: transparent !important;
}
</style>